import { render, staticRenderFns } from "./FlexibleBenefitConfirmDialog.vue?vue&type=template&id=45c6de66&"
import script from "./FlexibleBenefitConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./FlexibleBenefitConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports